import { Button } from "@mui/material";
import Alert from "components/alert";
import useApiCall from "hooks/useApiCall";
import usePermissions from "hooks/usePermissions";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { deleteReference, viewAllReference } from "../api/commissions";
import BulkActions from "./BulkActions";
import Header from "./Header";
import AddEdit from "./addEdit/AddEdit";
import AdvanceFilter from "./filter/AdvanceFilter";
import MainScreenFilter from "./filter/MainScreenFilter";
import MainTable from "./table/MainTable";
import ViewReference from "./viewReference/ViewReference";
import useQueries from "hooks/useQueries";
import Summary from "./Summary";
import NotAuthorized from "components/notAuthorized";
import useBase from "hooks/useBase";

const Commissions = () => {
  const { base, updateBase } = useBase();

  const { setQueries, openAddEdit, openView } = useQueries();
  const [activeMenu, setActiveMenu] = useState("");
  const [persistedData, setPersistedData] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [allReference, setAllReference] = useState([]);
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
  });

  const isFiltering = () => {
    let filtering = false;
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        if (filters[key].length > 0) filtering = true;
      } else {
        if (filters[key]) filtering = true;
      }
      filtering = true;
    }
    return filtering;
  };

  const { data, loading, fetchData: fetchListData } = useApiCall();
  useEffect(() => {
    let finalFilters = { ...filters };
    let finalPagination = { ...pagination };
    finalFilters.search = search;
    fetchListData(
      viewAllReference,
      {
        body_data: finalFilters,
        params: `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}&search=${search}`,
      },
      false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, search, pagination?.current_page, pagination?.per_page]);

  useEffect(() => {
    if (data) {
      const { data: allData, ...rest } = data;
      setAllReference(allData);
      setPagination(rest);
      setSelectedRows([]);
    }
  }, [data]);


  useEffect(() => {
    updateBase([
      "intakes",
      "references",
      "universities",
      "currencies",
      "branches",
      "applyThroughs",
    ]);
  }, [reload]);

  const [openAlert, setOpenAlert] = useState(false);

  const handleDelete = async (id) => {
    setOpenAlert(id);
  };

  const handleDeleteConfirm = async () => {
    if (allReference?.length > 1) {
      setAllReference(
        allReference.filter((customer) => customer?.id !== openAlert)
      );
      setOpenAlert(false);
      try {
        const result = await deleteReference({ id: openAlert });
        if (result.success) {
          toast.success(result?.message);
        } else {
          toast.error(result?.message);
        }
      } catch (error) {}
    } else {
      setOpenAlert(false);
      const result = await deleteReference({ id: openAlert });
      if (result.success) {
        toast.success(result?.message);
      } else {
        toast.error(result?.message);
      }
      setReload((pre) => !pre);
    }
    setSelectedRows([]);
  };

  const permissions = usePermissions("customer");

  const all_props = {
    ...base,
    persistedData,
    setPersistedData,
    setReload,
    filters,
    setFilters,
    isFiltering,
    pagination,
    setPagination,
    allReference,
    setAllReference,
    permissions,
  };

  // Bulk options
  const [selectedRows, setSelectedRows] = useState([]);

  const handleTableCheckBox = (id, checked) => {
    if (id === "all") {
      if (checked) {
        setSelectedRows(allReference?.map((customer) => customer?.id));
      } else {
        setSelectedRows([]);
      }
    } else {
      if (checked) {
        setSelectedRows([...selectedRows, id]);
      } else {
        setSelectedRows(selectedRows?.filter((customer) => customer !== id));
      }
    }
  };
  useEffect(() => {
    updateBase([
      "intakes",
      "references",
      "universities",
      "currencies",
      "branches",
      "applyThroughs",
      "projects"
    ]);
  }, [reload]);
  return (
    <div>
      {openAlert && (
        <Alert
          open={openAlert}
          handleClose={setOpenAlert}
          title="Delete References"
          desc="Are you sure you want to delete? Don't worry you will find this expense on Trash Menu"
          buttons={
            <>
              <Button onClick={() => setOpenAlert(false)}>No, keep it</Button>
              <Button variant="solid" onClick={handleDeleteConfirm}>
                Yes, delete it
              </Button>
            </>
          }
        />
      )}
      <Header
        {...{
          activeMenu,
          setActiveMenu,
          setOpenFilter,
          setSearch,
          isFiltering,
          setPagination,
          pagination,
          permissions,
          search,
          filters,
        }}
      />
      {activeMenu === "summary" && (
        <Summary filters={filters} search={search} />
      )}

      {openFilter && (
        <AdvanceFilter
          openDrawer={openFilter}
          setOpenDrawer={setOpenFilter}
          {...all_props}
        />
      )}

      {openAddEdit && (
        <AddEdit
          {...{
            openDrawer: openAddEdit,
            setOpenDrawer: () => setQueries(""),
            ...all_props,
          }}
        />
      )}

      {openView && (
        <ViewReference
          openDrawer={openView}
          setOpenDrawer={() => setQueries("")}
          {...all_props}
        />
      )}

      {!activeMenu &&
        !selectedRows?.length > 0 &&
        !!(permissions["list(own)"] || permissions["list(global)"]) && (
          <MainScreenFilter {...all_props} />
        )}
      {selectedRows?.length > 0 && (
        <BulkActions
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          {...all_props}
        />
      )}

      {!activeMenu &&
        (permissions["list(own)"] || permissions["list(global)"] ? (
          <MainTable
            handleDelete={handleDelete}
            loading={loading}
            handleTableCheckBox={handleTableCheckBox}
            selectedRows={selectedRows}
            {...all_props}
          />
        ) : (
          <NotAuthorized />
        ))}
    </div>
  );
};

export default Commissions;
